import React, { useState, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextInputForm, Calender } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import PageNav from "../../components/PageNav";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../../config/config";
import LoadingOverlay from "../../components/LoadingOverlay";
import debounce from "lodash.debounce";

const BankPledgeCreation = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isSubmitting = useRef(false);

  const today = new Date();
  const defaultDate = today.toISOString().substr(0, 10);

  const [formData, setFormData] = useState({
    edit_id: rowData?.id || "",
    customer_no: rowData?.customer_no || "",
    receipt_no: rowData?.receipt_no || "",
    bank_pledge_date: rowData?.bank_pledge_date || defaultDate,
    bank_assessor_name: rowData?.bank_assessor_name || "",
    bank_name: rowData?.bank_name || "",
    bank_pawn_value: rowData?.bank_pawn_value || "",
    bank_interest: rowData?.bank_interest || "",
    bank_due_date: rowData?.bank_due_date || "",
    bank_additional_charges: rowData?.bank_additional_charges || "",
    location: rowData?.bank_loan_no || rowData?.location || "", // Map from bank_loan_no or location
  });

  const [suggestions, setSuggestions] = useState([]);

  const handleChange = (e, field) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (field === "customer_no" || field === "receipt_no") {
      if (value.trim() === "") {
        setSuggestions([]);
      } else {
        fetchJewelPawnData(value);
      }
    }
  };

  const fetchJewelPawnData = debounce(async (text) => {
    if (!text) {
      setSuggestions([]);
      return;
    }
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: text, limit: 5, offset: 0 }),
      });

      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setLoading(false);
        setLoading(false);
        setSuggestions(responseData.body.pawnjewelry || []);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    
    setLoading(false);
  }
  }, 400);

  const handleSuggestionSelect = (item) => {
    setFormData((prev) => ({
      ...prev,
      customer_no: item.mobile_number || item.customer_no || prev.customer_no,
      receipt_no: item.receipt_no || "",
    }));
    setSuggestions([]);
  };

  const setLabel = (date, label) => {
    let dateString = date instanceof Date ? date.toISOString().substr(0, 10) : date;
    setFormData((prev) => ({ ...prev, [label]: dateString }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    setLoading(true);
if (isSubmitting.current) return;
    if (!formData.receipt_no) {
      toast.error("Please enter a Receipt No");
      setLoading(false);
        setLoading(false);
        return;
    }

    setLoading(true);
    isSubmitting.current = true;

    try {
      const response = await fetch(`${API_DOMAIN}/bank_pledge.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setLoading(false);
        setLoading(false);
        toast.success("Bank Pledge details saved successfully!");
        setTimeout(() => navigate("/console/bankpledge"), 1500);
      } else {
        setLoading(false);
        toast.error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting:", error);
      toast.error("Failed to save data.");
    
    setLoading(false);
  } finally {
      setLoading(false);
      isSubmitting.current = false;
    }
  };

  return (
    <div>
      <Container fluid>
        <Row className="py-3">
          <Col lg="12">
            <PageNav pagetitle={`Bank Pledge ${type === "edit" ? "Edit" : "Creation"}`} />
          </Col>
        </Row>

        <div className="card shadow-sm mb-4 border-0">
          <div className="card-header bg-white pt-4">
            <h5 className="fw-bold" style={{ color: "#000080" }}>Loan Information</h5>
          </div>
          <div className="card-body">
            <Row>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Customer No"
                  placeholder="Customer No"
                  value={formData.customer_no}
                  onChange={(e) => handleChange(e, "customer_no")}
                >
                  {suggestions.length > 0 && (
                    <ul className="suggestion-list">
                      {suggestions.map((item, idx) => (
                        <li key={idx} onClick={() => handleSuggestionSelect(item)}>
                          {item.name || item.customer_details} - {item.receipt_no} ({item.mobile_number})
                        </li>
                      ))}
                    </ul>
                  )}
                </TextInputForm>
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Receipt No"
                  placeholder="Receipt No"
                  name="receipt_no"
                  value={formData.receipt_no}
                  onChange={(e) => handleChange(e, "receipt_no")}
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="card shadow-sm mb-4 border-0">
          <div className="card-header bg-white pt-4">
            <h5 className="fw-bold" style={{ color: "#000080" }}>Bank Pledge Details</h5>
          </div>
          <div className="card-body">
            <Row>
              <Col lg="3" md="4" className="py-3">
                <Calender
                  setLabel={(date) => setLabel(date, "bank_pledge_date")}
                  initialDate={formData.bank_pledge_date}
                  calenderlabel="Bank Pledge Date"
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Bank Loan No"
                  placeholder="Bank Loan No"
                  name="location"
                  value={formData.location}
                  onChange={(e) => handleChange(e, "location")}
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Bank Assessor Name"
                  placeholder="Assessor Name"
                  name="bank_assessor_name"
                  value={formData.bank_assessor_name}
                  onChange={(e) => handleChange(e, "bank_assessor_name")}
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Bank Name"
                  placeholder="Bank Name"
                  name="bank_name"
                  value={formData.bank_name}
                  onChange={(e) => handleChange(e, "bank_name")}
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Bank Pawn Value"
                  placeholder="Value"
                  name="bank_pawn_value"
                  value={formData.bank_pawn_value}
                  onChange={(e) => handleChange(e, "bank_pawn_value")}
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Bank Interest"
                  placeholder="Interest"
                  name="bank_interest"
                  value={formData.bank_interest}
                  onChange={(e) => handleChange(e, "bank_interest")}
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <Calender
                  setLabel={(date) => setLabel(date, "bank_due_date")}
                  initialDate={formData.bank_due_date}
                  calenderlabel="BankDue Date"
                />
              </Col>
              <Col lg="3" md="4" className="py-3">
                <TextInputForm
                  labelname="Closing Amount"
                  placeholder="Closing Amount"
                  name="bank_additional_charges"
                  value={formData.bank_additional_charges}
                  onChange={(e) => handleChange(e, "bank_additional_charges")}
                />
              </Col>
            </Row>
          </div>
        </div>

        <Row>
          <Col className="text-center py-4">
            <span className="mx-2">
              <ClickButton label="Submit" disabled={loading} onClick={handleSubmit} disabled={loading} />
            </span>
            <span className="mx-2">
              <ClickButton label="Cancel" onClick={() => navigate("/console/bankpledge")} />
            </span>
          </Col>
        </Row>

        <ToastContainer />
        {loading && <LoadingOverlay isLoading={loading} />}
      </Container>
    </div>
  );
};

export default BankPledgeCreation;
